import request from '@/utils/request'

// 根据平台编码获取对应的类目集合,转化成树
export function listPlatType(params) {
    return request({
        url: '/server/plat/type/list',
        method: 'get',
        params:params,
    })
}

export function getProductTypeList(params) {
    return request({
        url: '/server/plat/type/tree',
        method: 'get',
        params:params,
    })
}

export function uploadTemplate(params) {
    return request({
        url: '/server/pro/upload',
        method: 'post',
        data: params,
    })
}

export function getPlatTypeTree(params) {
    return request({
        url: '/platform/Category/list',
        method: 'get',
        params:params,
    })
}

export function addPlatType(data) {
    return request({
        url: '/server/plat/type/add',
        method: 'post',
        data: data
    })
}

export function updatePlatType(data) {
    return request({
        url: '/server/plat/type/edit',
        method: 'post',
        data: data
    })
}

export function delPlatType(id) {
    return request({
        url:'/server/plat/type/delete/'+id,
        method:'post'
    })
}


// 根据ID获取name
export function getPlatTypeName(id) {
    return request({
        url: '/platform/Category/' + id,
        method: 'get'
    })
}


// 根据ID获取name
export function getPlatTypeNames(ids) {
    var intIds=[];
    ids.forEach(items => {
        intIds.push(parseInt(items))
    });
    ids=intIds
    return request({
        url: '/platform/Category/getPlatTypeNames/'+ids,
        method: 'get',
    })
}


export function getPlatTypeList(params) {
    return request({
        url: '/platform/Category/getPlatTypeList',
        method: 'get',
        params:params,
    })
}

export function treeView(params) {
    return request({
        url: '/platform/Category/treeView',
        method: 'get',
        params:params,
    })
}

//类目下的基础属性集合
export function getList(params) {
    return request({
        url: '/server/pro/getList',
        method: 'get',
        params:params,
    })
}

export function getSplictName(ids) {
    return request({
        url: '/platform/Category/getSplictName/'+ids,
        method: 'get',
    })
}

export function getAllShop() {
    return request({
        url:'/plat/getAllShop',
        method:'get'
    })
}

export function getProList(params) {
    return request({
        url:'/server/pro/list',
        method:'GET',
        params: params
    })
}



export function getTemplateTypeList(platId) {
    return request({
        url: '/server/plat/type/tree/' + platId,
        method: 'get',
    })
}
